export const DOWNLOAD_VALUE_PROPOSITION_REPORT = 'DOWNLOAD_VALUE_PROPOSITION_REPORT';
export const DOWNLOAD_VALUE_PROPOSITION_REPORT_SUCCESS = 'DOWNLOAD_VALUE_PROPOSITION_REPORT_SUCCESS';
export const DOWNLOAD_VALUE_PROPOSITION_REPORT_FAILED = 'DOWNLOAD_VALUE_PROPOSITION_REPORT_FAILED';

export const DOWNLOAD_CLIENT_REPORT = 'DOWNLOAD_CLIENT_REPORT';
export const DOWNLOAD_CLIENT_REPORT_SUCCESS = 'DOWNLOAD_CLIENT_REPORT_SUCCESS';
export const DOWNLOAD_CLIENT_REPORT_FAILED = 'DOWNLOAD_CLIENT_REPORT_FAILED';

export const DOWNLOAD_CLIENT_STATEMENT_LIST_REPORT = 'DOWNLOAD_CLIENT_STATEMENT_LIST_REPORT';
export const DOWNLOAD_CLIENT_STATEMENT_LIST_REPORT_SUCCESS = 'DOWNLOAD_CLIENT_STATEMENT_LIST_REPORT_SUCCESS';
export const DOWNLOAD_CLIENT_STATEMENT_LIST_REPORT_FAILED = 'DOWNLOAD_CLIENT_STATEMENT_LIST_REPORT_FAILED';
